// 运行时配置
import React from 'react';
import { Button, Result } from 'antd';
import { history } from '@umijs/max';
import { RunTimeLayoutConfig } from '@umijs/max';
import { SupabaseAuth, getSupabaseClient } from '@/utils/supabase';
import { userRoleService } from '@/services/supabase';
import RightContent from '@/components/RightContent';
import logo from '@/assets/logo.png';
import onlyLogo from '@/assets/onlyLogo.png';
import dashboard from "@/assets/sidebar/dashboard.svg";
import devide from "@/assets/sidebar/devide.svg";
import edit from "@/assets/sidebar/edit.svg";
import map from "@/assets/sidebar/map.svg";
import icon from "@/assets/sidebar/icon.svg";
import icon2 from '@/assets/sidebar/icon2.svg';
import stat from '@/assets/sidebar/stat.svg';
import bar from '@/assets/sidebar/bar.svg';

export async function getInitialState(): Promise<{
  name?: string;
  avatar?: string;
  currentUser?: any;
  publicUserData?: any;
  settings?: any;
}> {
  try {
    const { session } = await SupabaseAuth.getSession();

    if (session?.user) {
      // Fetch user data from public.users table
      const supabase = getSupabaseClient();
      const { data: userData, error: userError } = await supabase
        .from('users')
        .select('*')
        .eq('user_id', session.user.id)
        .single();

      if (userError) {
        console.warn('Could not fetch user data from public.users:', userError);
      }

      // Fetch user's roles
      const rolesResult = await userRoleService.getUserRoles(session.user.id);
      const userRoles = rolesResult.success ? rolesResult.data : [];

      // Merge auth user with public.users data
      const fullUserData = {
        ...session.user,
        first_name: userData?.first_name || session.user.user_metadata?.first_name,
        last_name: userData?.last_name || session.user.user_metadata?.last_name,
        avatar_url: userData?.avatar_url || session.user.user_metadata?.avatar_url,
        stations: userData?.stations || [],
        roles: userRoles,
      };

      // Store roles in publicUserData as well for access control
      const publicDataWithRoles = {
        ...userData,
        roles: userRoles,
      };

      return {
        name: `${fullUserData.first_name || ''} ${fullUserData.last_name || ''}`.trim() || session.user.email || 'User',
        avatar: fullUserData.avatar_url,
        currentUser: fullUserData,
        publicUserData: publicDataWithRoles,
        settings: {},
      };
    }
  } catch (error) {
    console.error('Get initial state error:', error);
  }
  
  return {
    settings: {},
  };
}

export const layout: RunTimeLayoutConfig = ( { initialState } ) => {
  const [collapsed, setCollapsed] = React.useState<boolean>(false);

  return {
    title: false,
    unAccessible: React.createElement(Result, {
      status: '403',
      title: '403',
      subTitle: 'Bạn không có quyền truy cập trang này.',
      extra: React.createElement(
        Button,
        { type: 'primary', onClick: () => history.push('/') },
        'Về trang chủ',
      ),
    }),
    logo: collapsed ? onlyLogo : logo,
    menu: {
      locale: false,
    },
    collapsed: collapsed,
    onCollapse: (collapsed: boolean) => {
      setCollapsed(collapsed);
    },
    menuDataRender: (menuData) => {
      return menuData.map((item) => {
        let menuIcon = item.icon;
        if (item.path === '/dashboard') {
          menuIcon = React.createElement('img', {
            src: icon,
            alt: 'icon',
            style: { width: 16, height: 16 },
          });
        } else if (item.path === '/content-management') {
          menuIcon = React.createElement('img', {
            src: bar,
            alt: 'content',
            style: { width: 16, height: 16 },
          });
        } else if (item.path === '/devices-pricing') {
          menuIcon = React.createElement('img', {
            src: devide,
            alt: 'devices',
            style: { width: 16, height: 16 },
          });
        } else if (item.path === '/map') {
          menuIcon = React.createElement('img', {
            src: map,
            alt: 'map',
            style: { width: 16, height: 16 },
          });
        } else if (item.path === '/users') {
          menuIcon = React.createElement('img', {
            src: icon2,
            alt: 'users',
            style: { width: 16, height: 16 },
          });
        } else if (item.path === '/roles') {
          menuIcon = React.createElement('img', {
            src: edit,
            alt: 'roles',
            style: { width: 16, height: 16 },
          });
        } else if (item.path === '/reports') {
          menuIcon = React.createElement('img', {
            src: dashboard,
            alt: 'reports',
            style: { width: 16, height: 16 },
          });
        } else if (item.path === '/ev-stations') {
          menuIcon = React.createElement('img', {
            src: stat,
            alt: 'stations',
            style: { width: 16, height: 16 },
          });
        } else if (item.path === '/station-status') {
          menuIcon = React.createElement('img', {
            src: dashboard,
            alt: 'station-status',
            style: { width: 16, height: 16 },
          });
        }
        return {
          ...item,
          icon: menuIcon,
          children: item.children ? item.children : undefined,
        };
      });
    },
    avatarProps: {
      src: initialState?.currentUser?.avatar,
      title: initialState?.currentUser?.name,
      size: 'small',
    },
    // waterMarkProps: {
    //   content: initialState?.currentUser?.name || 'EV Bike Admin',
    // },
    rightRender: () => React.createElement(RightContent, { collapsed }),
    onPageChange: async () => {
      const { location } = history;
      const publicPaths = ['/login'];

      try {
        const { session } = await SupabaseAuth.getSession();
        const hasSession = !!session?.user;

        console.log(
          'Page changed to:',
          location.pathname,
          'Has session:',
          hasSession,
        );

        // Allow access to public pages without authentication
        if (!hasSession && !publicPaths.includes(location.pathname)) {
          console.log('No session, redirecting to login');
          history.push('/login');
        }

        // Redirect to dashboard if already logged in and trying to access login/register
        if (hasSession && publicPaths.includes(location.pathname)) {
          console.log(
            'Has session but on public page, redirecting to dashboard',
          );
          history.push('/dashboard');
        }
      } catch (error) {
        console.error('Page change error:', error);
      }
    },
  };
};
